const COLORS = {
  primary: "primary",
  success: "success",
  danger: "danger",
  warning: "warning",
  info: "info",
  light: "light",
  dark: "dark",
  secondary: "secondary",
};

export const StatusBadge = ({ status, text, noOutline }) => {
  const STATUS_MAP = {
    text: (
      <Badge noOutline={noOutline} color={COLORS.light} text={text || "text"} />
    ),

    active: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "active"}
      />
    ),

    inactive: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "inactive"}
      />
    ),

    dispute: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "dispute"}
      />
    ),

    issued: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "issued"}
      />
    ),

    completed: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "completed"}
      />
    ),

    approved: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "approved"}
      />
    ),

    verified: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "verified"}
      />
    ),

    settled: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "settled"}
      />
    ),

    enquired: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "enquired"}
      />
    ),

    settled: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "settled"}
      />
    ),

    allocated: (
      <Badge
        noOutline={noOutline}
        color={COLORS.info}
        text={text || "allocated"}
      />
    ),

    initiated: (
      <Badge
        noOutline={noOutline}
        color={COLORS.light}
        text={text || "initiated"}
      />
    ),

    info: (
      <Badge
        noOutline={noOutline}
        color={COLORS.info}
        text={text || "allocated"}
      />
    ),

    activation_request: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "activation reqs"}
      />
    ),

    pending: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "pending"}
      />
    ),

    review_pending: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "review pending"}
      />
    ),

    requested: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "requested"}
      />
    ),

    suspend: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "suspend"}
      />
    ),

    submitted: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "submitted"}
      />
    ),

    "in complete": (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "incomplete"}
      />
    ),

    incomplete: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "incomplete"}
      />
    ),

    in_complete: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "incomplete"}
      />
    ),

    order_generated: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "order generated"}
      />
    ),

    drafted: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "drafted"}
      />
    ),

    requested: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "requested"}
      />
    ),

    suspend: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "suspend"}
      />
    ),

    unsettled: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "unsettled"}
      />
    ),

    inprocess: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "in process"}
      />
    ),

    permenent_block: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "permanent block"}
      />
    ),

    cancelled: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "cancelled"}
      />
    ),

    temporary_block: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "temporary block"}
      />
    ),

    declined: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "declined"}
      />
    ),

    rejected: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "rejected"}
      />
    ),

    permanent_block_request: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "permanent block reqs"}
      />
    ),

    temporary_block_request: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "temporary block reqs"}
      />
    ),

    close_card_request: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "close card reqs"}
      />
    ),

    danger: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "rejected"}
      />
    ),

    failed: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "failed"}
      />
    ),

    failed_retry: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "Failed Retry"}
      />
    ),

    failed_no_retry: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "Failed No Retry"}
      />
    ),

    salary_credit: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "Salary Credit"}
      />
    ),

    receivables_pending: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "receivables pending"}
      />
    ),

    yet_to_settle: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "yet to settle"}
      />
    ),

    processed: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "sent to bank"}
      />
    ),

    processing: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "processing"}
      />
    ),

    awaiting_response: (
      <Badge
        noOutline={noOutline}
        color={COLORS.warning}
        text={text || "awaiting response"}
      />
    ),

    success: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "Success"}
      />
    ),

    accepted: (
      <Badge
        noOutline={noOutline}
        color={COLORS.success}
        text={text || "Accepted"}
      />
    ),

    cancelled: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "cancelled"}
      />
    ),

    not_accepted: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "not accepted"}
      />
    ),

    expired: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "Expired"}
      />
    ),

    restricted: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "Restricted"}
      />
    ),

    closed: (
      <Badge
        noOutline={noOutline}
        color={COLORS.danger}
        text={text || "Closed"}
      />
    ),
  };

  return STATUS_MAP[status?.toLowerCase()];
};

const Badge = ({ color, text, noOutline }) => {
  return (
    <>
      <span
        className={`alert alert-${
          COLORS[color]
        } text-uppercase text-center p-1 px-2 m-0 ${
          noOutline && "border-0 bg-white fw-bold"
        }`}
        style={{
          minWidth: "120px",
          display: "inline-block",
          fontWeight: "500",
          fontSize: "12px",
        }}
      >
        <small>{text}</small>
      </span>
    </>
  );
};
